var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.messages
    ? _c(
        "div",
        { ref: "wrapper" },
        [
          _vm._l(_vm.messages, function(msg) {
            return [
              _c("b-alert", { attrs: { variant: msg.type, show: "" } }, [
                _vm._v(_vm._s(msg.message))
              ])
            ]
          })
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-62dade92", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-62dade92","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/Messages.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-62dade92","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/Messages.vue
// module chunks = 0